var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2051 1.63891L2.95509 16.6389C2.72399 16.8523 2.58829 17.1495 2.57868 17.464C2.56899 17.7784 2.6861 18.0834 2.90368 18.3106L13.4574 29.3297L19.1537 35.277C19.3748 35.5078 19.6805 35.6383 20 35.6383L25.6233 16.25L19.9999 1.32812C19.7147 1.32812 19.4295 1.43172 19.2051 1.63891Z",
    fill: "#FDBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0448 16.6389L20.7948 1.63891C20.5704 1.43172 20.2852 1.32812 20 1.32812V35.6383C20.3195 35.6383 20.6252 35.5078 20.8463 35.277L37.0963 18.3105C37.3139 18.0834 37.431 17.7783 37.4213 17.4639C37.4116 17.1495 37.276 16.8523 37.0448 16.6389Z",
    fill: "#FF9F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0C8.10281 0 7.57812 0.524687 7.57812 1.17188V28.75H20L26.2109 14.375L20 0H8.75Z",
    fill: "#EBF3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4219 1.17188C32.4219 0.524687 31.8972 0 31.25 0H20V28.75H32.4219V1.17188Z",
    fill: "#D4E6FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6714 9.24957C16.2137 9.70723 16.2137 10.4492 16.6714 10.9068C16.9001 11.1357 17.2 11.25 17.5 11.25C17.7999 11.25 18.0998 11.1357 18.3286 10.9068L20 9.23543L21.4611 6.69887L20 5.9209L16.6714 9.24957Z",
    fill: "#8AB9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3286 4.24949C22.871 3.79184 22.129 3.79184 21.6713 4.24949L20 5.92082V9.23535L23.3286 5.90676C23.7862 5.44902 23.7862 4.70707 23.3286 4.24949Z",
    fill: "#7880DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 13.9062C16.2278 13.9062 15.7031 14.4309 15.7031 15.0781C15.7031 15.7253 16.2278 16.25 16.875 16.25H20L21.3281 15.0781L20 13.9062H16.875Z",
    fill: "#8AB9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2969 15.0781C24.2969 14.4309 23.7722 13.9062 23.125 13.9062H20V16.25H23.125C23.7722 16.25 24.2969 15.7253 24.2969 15.0781Z",
    fill: "#7880DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.2812C16.2278 18.2812 15.7031 18.8059 15.7031 19.4531C15.7031 20.1003 16.2278 20.625 16.875 20.625H20L21.0622 19.4531L20 18.2812H16.875Z",
    fill: "#8AB9F9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 18.2812H20V20.625H23.125C23.7722 20.625 24.2969 20.1003 24.2969 19.4531C24.2969 18.8059 23.7722 18.2812 23.125 18.2812Z",
    fill: "#7880DA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25C18.1472 6.25 18.6719 5.72533 18.6719 5.07812C18.6719 4.43092 18.1472 3.90625 17.5 3.90625C16.8528 3.90625 16.3281 4.43092 16.3281 5.07812C16.3281 5.72533 16.8528 6.25 17.5 6.25Z",
    fill: "#8AB9F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.25C23.1472 11.25 23.6719 10.7253 23.6719 10.0781C23.6719 9.43092 23.1472 8.90625 22.5 8.90625C21.8528 8.90625 21.3281 9.43092 21.3281 10.0781C21.3281 10.7253 21.8528 11.25 22.5 11.25Z",
    fill: "#7880DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5347 27.7065L2.57812 17.5V38.8281C2.57812 38.9693 2.60344 39.1064 2.6507 39.2343L4.51195 39.7185L16.5018 29.458C16.7561 29.2403 16.9052 28.9243 16.9116 28.5896C16.9178 28.2549 16.7807 27.9335 16.5347 27.7065Z",
    fill: "#FFD400"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4649 27.7065C23.219 27.9335 23.0818 28.2549 23.0881 28.5896C23.0944 28.9243 23.2435 29.2403 23.4979 29.458L35.4877 39.7185L37.349 39.2343C37.3962 39.1065 37.4215 38.9693 37.4215 38.8281V17.5L23.4649 27.7065Z",
    fill: "#FDBF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2377 24.0315L2.65039 39.2343C2.82039 39.6945 3.25906 40 3.74961 40H19.9996L23.6715 32.5516L19.9996 23.75C19.7283 23.75 19.4569 23.8438 19.2377 24.0315Z",
    fill: "#FFE470"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.762 24.0315C20.5427 23.8438 20.2713 23.75 20 23.75V40H36.25C36.7405 40 37.1792 39.6945 37.3492 39.2343L20.762 24.0315Z",
    fill: "#FFD400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess1);
export default __webpack_public_path__ + "static/media/process1.605aa7d317fc790808028f183fff20f4.svg";
export { ForwardRef as ReactComponent };